<template>
  <!-- 管理员-岗位添加页面进度3 -->
  <div class="main-css">
    <div class="main-box">
      <!-- 标题部分 -->
      <div class="top-title">{{ $t("postingJobOffer") }}</div>
      <!-- 进度条部分 -->
      <div class="progress-bar">
        <div class="line-between-active"></div>
        <div class="progress-item-active">
          1 <span class="progress-title">{{ $t("workContent") }}</span>
        </div>
        <div class="line-center-active"></div>
        <div class="progress-item-active">
          2<span class="progress-title">{{ $t("salaryConditions") }}</span>
        </div>
        <div class="line-center-active"></div>
        <div class="progress-item-active">
          3<span class="progress-title">{{ $t("confirm") }}</span>
        </div>
        <div class="line-between-active"></div>
      </div>
      <!-- 主要信息部分 -->
      <div class="main-info-box">
        <!-- 左边部分 -->
        <div class="left-box">
          <!-- 左边第一行 -->
          <div class="left-inline-box">
            <div class="left-top-title">{{ $t("projectTitle") }}</div>
            <div class="left-bottom-title">
              {{ jobName }}
            </div>
          </div>
          <!-- 左边照片行 -->
          <div class="left-img-box">
            <img
              :src="urlList[0]?urlList[0]:'@/assets/defaultImg.png'"
              alt=""
              @error="
                e => {
                  e.target.src = require('@/assets/defaultImg.png');
                }
              "
            />
            <img
            :src="urlList[1]?urlList[1]:'@/assets/defaultImg.png'"
              alt=""
              @error="
                e => {
                  e.target.src = require('@/assets/defaultImg.png');
                }
              "
            />
            <img
            :src="urlList[2]?urlList[2]:'@/assets/defaultImg.png'"
              alt=""
              @error="
                e => {
                  e.target.src = require('@/assets/defaultImg.png');
                }
              "
            />
          </div>
          <!--左边第三行 -->
          <div class="label-line-box">
            <div :class="label1 ? 'label-box-active' : 'label-box'">
              {{ $t("foreignersWelcome") }}<span>×</span>
            </div>
            <div :class="label2 ? 'label-box-active' : 'label-box'">
              {{ $t("inexperiencedOK") }}<span>×</span>
            </div>
            <div :class="label3 ? 'label-box-active' : 'label-box'">
              {{ $t("newGraduateOK") }}<span>×</span>
            </div>
            <div :class="label4 ? 'label-box-active' : 'label-box'">
              {{ $t("educationalBackgroundMatter") }}<span>×</span>
            </div>
          </div>
          <!-- 左边第四行 -->
          <div class="inline-normal-box">
            <div class="normal-box">
              <div class="normal-top-box-name">
                {{ $t("occupationCategory") }}
              </div>
              <div class="normal-bottom-box-name">{{ workType }}</div>
            </div>
            <div class="normal-box">
              <div class="normal-top-box-name">
                {{ $t("workLocation") }}
              </div>
              <div class="normal-bottom-box-name">{{ workSpace }}</div>
            </div>
          </div>
          <!-- 左边第五行 -->
          <div class="inline-normal-box">
            <div class="normal-box">
              <div class="normal-top-box-name">
                {{ $t("employmentForm") }}
              </div>
              <div
                class="normal-bottom-box-nameType"
                v-for="(item, index) in labelListHandle"
                :key="index"
              >
                {{ item }}
              </div>
            </div>
            <div class="normal-box">
              <div class="normal-top-box-name">
                {{ $t("dutyTime") }}
              </div>
              <div class="normal-bottom-box-name">{{ workTime }}</div>
            </div>
          </div>
          <!-- 左边第六行 -->
          <div class="inline-normal-box">
            <div class="normal-box">
              <div class="normal-top-box-name">
                {{ $t("salary") }}
              </div>
              <div class="normal-bottom-box-name">
                {{ salaryType }} {{ startSalary }}
              </div>
            </div>
            <div class="normal-box">
              <div class="normal-top-box-name">
                {{ $t("numberOfHires") }}
              </div>
              <div class="normal-bottom-box-name">{{ recruitNumber }}名</div>
            </div>
          </div>
          <!-- 左边第七行 -->
          <div class="inline-normal-box">
            <div class="normal-box">
              <div class="normal-top-box-name">
                {{ $t("recruiter") }}
              </div>
              <div class="normal-bottom-box-name">{{ recruiter }}</div>
            </div>
            <div class="normal-box">
              <div class="normal-top-box-name">
                {{ $t("targetRecruitmentTime") }}
              </div>
              <div class="normal-bottom-box-name">{{ principalTime }}</div>
            </div>
          </div>
        </div>
        <!-- 右边部分 -->
        <div class="right-box">
          <!-- 第一行 -->
          <div class="right-normal-box">
            <div class="right-box-top">{{ $t("workContent") }}</div>
            <div class="right-box-bottom">
              {{ workContent }}
            </div>
          </div>
          <!-- 第二行 -->
          <div class="right-normal-box">
            <div class="right-box-top">{{ $t("employmentConditions") }}</div>
            <div class="right-box-bottom">
              {{ employmentConditions }}
            </div>
          </div>
          <!-- 第三行 -->
          <div class="right-normal-box">
            <div class="right-box-top">{{ $t("welfare") }}</div>
            <div class="right-box-bottom">
              {{ welfareTreatment }}
            </div>
          </div>
          <!-- 第四行 -->
          <div class="right-normal-box">
            <div class="right-box-top">{{ $t("other") }}</div>
            <div class="right-box-bottom">
              {{ other }}
            </div>
          </div>
        </div>
      </div>
      <!-- button -->
      <div class="line-button-box">
        <button class="button-css1" @click="returnClick">
          {{ $t("return") }}
        </button>
        <!--        <button class="button-css1" @click="saveClick">{{ $t("temporarilySaved") }}</button>-->
        <button class="button-css2" @click="releaseJobClick">
          {{ $t("jobPosting") }}
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import { saveJobInfo, releaseJobInfo } from "../../js/api";

export default {
  name: "adminPostAddPageProgressThree",
  components: {},
  data() {
    return {
      salaryType: "", //给与类型---2
      startSalary: 0, //起薪--------------2
      endSalary: 0, //结束薪资--------2
      labelListHandle: [],
      employmentForm1: 0, //雇佣形式1--------2
      employmentForm2: 0, //雇佣形式2--------2
      employmentForm3: 0, //雇佣形式3--------2
      employmentForm4: 0, //雇佣形式4--------2
      welfareTreatment: "", //福利待遇-------2
      employmentConditions: "", //录用条件---2
      other: "", //其他---------------------2
      hourSalary: 0, //期望薪资----------?
      jobName: "", //事件名-----------1
      jobPhoto1: "", //事件照片1------1
      jobPhoto2: "", //事件照片2-------1
      jobPhoto3: "", //事件照片3--------1
      label1: 0, //标签1--------1
      label2: 0, //标签2--------1
      label3: 0, //标签3--------1
      label4: 0, //标签4--------1
      principalTime: "", //目标录用时间------1
      recruitNumber: "", //录用人数----------1
      workContent: "", //工作内容-----1
      workSpace: "", //工作地--------1
      workTime: "", //工作时间-------1
      workType: "", //工作种类--------1
      recruiter: "", //採用担当
      userId: "",
      inputData1: "",
      inputData2: "",
      urlList: [],
      pathsList: [],
      medicalId: ""
    };
  },
  created() {
    this.jobName = this.$route.params.jobName;
    this.jobPhoto1 = this.$route.params.jobPhoto1;
    this.jobPhoto2 = this.$route.params.jobPhoto2;
    this.jobPhoto3 = this.$route.params.jobPhoto3;
    this.workType = this.$route.params.workType;
    this.recruitNumber = this.$route.params.recruitNumber;
    this.workSpace = this.$route.params.workSpace;
    this.workTime = this.$route.params.workTime;
    this.recruiter = this.$route.params.recruiter;
    this.userId = this.$route.params.userId;
    this.principalTime = this.$route.params.principalTime;
    this.label1 = this.$route.params.label1;
    this.label2 = this.$route.params.label2;
    this.label3 = this.$route.params.label3;
    this.label4 = this.$route.params.label4;
    this.workContent = this.$route.params.workContent;
    //2
    this.salaryType = this.$route.params.salaryType;
    this.startSalary = this.$route.params.startSalary;
    this.endSalary = this.$route.params.endSalary;
    this.labelListHandle = this.$route.params.labelListHandle;
    this.employmentForm1 = this.$route.params.employmentForm1;
    this.employmentForm2 = this.$route.params.employmentForm2;
    this.employmentForm3 = this.$route.params.employmentForm3;
    this.employmentForm4 = this.$route.params.employmentForm4;
    this.welfareTreatment = this.$route.params.welfareTreatment;
    this.employmentConditions = this.$route.params.employmentConditions;
    this.other = this.$route.params.other;

    this.inputData1 = this.$route.params.inputData1;
    this.inputData2 = this.$route.params.inputData2;
    this.pathsList = this.$route.params.pathsList;
    this.medicalId = this.$route.params.medicalId;
    if (this.pathsList[0] !== "") {
      this.urlList = this.$route.params.urlList;
    }
  },
  computed: {},
  destroyed() {
    window.removeEventListener("setItemEvent", this.languageChange, true);
  },
  mounted() {
    window.addEventListener("setItemEvent", this.languageChange, true);
  },
  methods: {
    //监听语言
    languageChange(e) {
      const that = this;
      console.log("------监听数据------");
      console.log(e);
      if (e.key && e.key === "language" && e.newValue) {
        that.language = e.newValue;
      }
    },
    returnClick() {
      this.$router.push({
        path: "/adminPostAddPageProgressTwo",
        params: this.$route.params
      });
    },
    // saveClick(){
    //   var fakeInfo = {
    //     employmentConditions: this.employmentConditions,//录用条件---2
    //     employmentForm1: this.employmentForm1,//雇佣形式1--------2
    //     employmentForm2: this.employmentForm2,//雇佣形式2--------2
    //     employmentForm3: this.employmentForm3,//雇佣形式3--------2
    //     employmentForm4: this.employmentForm4,//雇佣形式4--------2
    //     endSalary: this.endSalary,//结束薪资--------2
    //     hourSalary: this.inputData2,//期望薪资
    //     jobName: this.jobName,//事件名-----------1
    //     jobPhoto1: this.jobPhoto1,//事件照片1------1
    //     jobPhoto2: this.jobPhoto2,//事件照片2-------1
    //     jobPhoto3: this.jobPhoto3,//事件照片3--------1
    //     label1: this.label1,//标签1--------1
    //     label2: this.label2,//标签2--------1
    //     label3: this.label3,//标签3--------1
    //     label4: this.label4,//标签4--------1
    //     other: this.other,//其他--------------------2
    //     principalTime: this.principalTime,//目标录用时间------1
    //     recruitNumber: this.recruitNumber,//录用人数----------1
    //     startSalary: this.startSalary,//起薪--------------2
    //     welfareTreatment: this.welfareTreatment,//福利待遇------2
    //     workContent: this.workContent,//工作内容-----1
    //     workSpace: this.workSpace,//工作地--------1
    //     workTime: this.workTime,//工作时间-------1
    //     workType: this.inputData1//工作种类--------1
    //   }
    //   saveJobInfo(fakeInfo).then((res) => {
    //     console.log("求人信息添加保存3接口");
    //     console.log(res);
    //   }).catch((res) => {
    //   })
    // },
    releaseJobClick() {
      var fakeInfo = {
        employmentConditions: this.employmentConditions, //录用条件---2
        employmentForm1: this.employmentForm1, //雇佣形式1--------2
        employmentForm2: this.employmentForm2, //雇佣形式2--------2
        employmentForm3: this.employmentForm3, //雇佣形式3--------2
        employmentForm4: this.employmentForm4, //雇佣形式4--------2
        endSalary: this.endSalary, //结束薪资--------2
        hourSalary: this.inputData2, //期望薪资
        jobName: this.jobName, //事件名-----------1
        userId: this.userId,
        jobPhoto1: this.jobPhoto1, //事件照片1------1
        jobPhoto2: this.jobPhoto2, //事件照片2-------1
        jobPhoto3: this.jobPhoto3, //事件照片3--------1
        label1: this.label1, //标签1--------1
        label2: this.label2, //标签2--------1
        label3: this.label3, //标签3--------1
        label4: this.label4, //标签4--------1
        other: this.other, //其他--------------------2
        principalTime: this.principalTime, //目标录用时间------1
        recruitNumber: this.recruitNumber, //录用人数----------1
        startSalary: this.startSalary, //起薪--------------2
        welfareTreatment: this.welfareTreatment, //福利待遇------2
        workContent: this.workContent, //工作内容-----1
        workSpace: this.workSpace, //工作地--------1
        workTime: this.workTime, //工作时间-------1
        workType: this.inputData1 //工作种类--------1
      };
      releaseJobInfo(fakeInfo)
        .then(res => {
          console.log("求人信息发布接口");
          console.log(res);

          if (res.data.code === "A0000") {
            this.$message({
              message: this.$t("releaseSuccess"),
              type: "success"
            });
            this.$router.push("/administratorCaseManagement");
          } else {
            this.$message.error(this.$t("releaseFail"));
          }
        })
        .catch(res => {});
    }
  }
};
</script>
<style scoped>
.main-css {
  width: 100%;
  height: 100%;
  background: #fff;
}
.main-box {
  /* width: 1200px;
  height: 100%; */
  margin: 0 auto;
  padding: 0 55px;
  box-sizing: border-box;
}
.top-title {
  height: 40px;
  line-height: 40px;
  text-align: center;
  font-weight: 500;
  font-size: 18px;
  color: #686868;
  margin-top: 20px;
}
.progress-bar {
  height: 40px;
  width: 100%;
  margin-top: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 40px;
}
.line-between-active {
  height: 2px;
  width: 80px;
  background: #51abff;
}
.progress-item-active {
  width: 20px;
  height: 20px;
  line-height: 20px;
  background: #51abff;
  border-radius: 50%;
  text-align: center;
  font-weight: 400;
  font-size: 13px;
  color: #ffffff;
  position: relative;
}
.progress-title {
  position: absolute;
  left: 50%;
  bottom: -30px;
  margin-left: -75px;
  display: block;
  height: 24px;
  width: 150px;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  text-align: center;
  color: #252a31;
}
.line-center-active {
  width: 160px;
  height: 2px;
  background: #51abff;
}
.progress-item-normal {
  width: 20px;
  height: 20px;
  line-height: 20px;
  background: #dce3e9;
  border-radius: 50%;
  text-align: center;
  font-weight: 400;
  font-size: 13px;
  color: #252a31;
  position: relative;
}
.main-info-box {
  width: 100%;
  height: 550px;
  display: flex;
}
.left-box {
  width: 50%;
}
.left-inline-box {
  height: 56px;
  width: 100%;
}
.left-top-title {
  height: 22px;
  line-height: 22px;
  width: 441px;
  border-bottom: 1px solid #686868;
  font-weight: 700;
  font-size: 14px;
  color: #686868;
}
.left-bottom-title {
  height: 34px;
  line-height: 34px;
  font-weight: 500;
  font-size: 18px;
  color: #686868;
}
.left-img-box {
  height: 114px;
  width: 95%;
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
}
.left-img-box img {
  height: 114px;
  width: 150px;
}
.left-label-box {
  height: 30px;
  width: 95%;
  background: #fff;
  margin-top: 5px;
}

.label-line-box {
  width: 99%;
  height: 30px;
  margin-top: 5px;
}
.label-box {
  float: left;
  height: 24px;
  padding: 0 2px;
  line-height: 24px;
  background: #b2b2b2;
  border-radius: 4px;
  font-weight: 400;
  font-size: 14px;
  cursor: pointer;
  overflow: hidden;
  color: #fff;
  margin-right: 20px;
}
.label-box-active {
  float: left;
  height: 24px;
  padding: 0 2px;
  line-height: 24px;
  background: #51abff;
  border-radius: 4px;
  font-weight: 400;
  font-size: 14px;
  color: #ffffff;
  cursor: pointer;
  overflow: hidden;
  margin-right: 20px;
}
.label-box-active span {
  height: 13px;
  width: 13px;
  background: #fff;
  border-radius: 50%;
  line-height: 13px;
  text-align: center;
  margin-left: 10px;
  display: inline-block;
  color: #b2b2b2;
}
.label-box span {
  height: 13px;
  width: 13px;
  background: #fff;
  border-radius: 50%;
  line-height: 13px;
  text-align: center;
  margin-left: 10px;
  display: inline-block;
  color: #b2b2b2;
}
.inline-normal-box {
  height: 60px;
  width: 95%;
  background: #fff;
  display: flex;
  margin-top: 15px;
}
.normal-box {
  width: 50%;
  height: 60px;
  padding: 0 15px;
  box-sizing: border-box;
}
.normal-top-box-name {
  width: 200px;
  height: 25px;
  box-sizing: border-box;
  border-bottom: 1px solid #686868;
  font-weight: 700;
  font-size: 14px;
  line-height: 25px;
  color: #686868;
}
.normal-bottom-box-name {
  height: 25px;
  width: 200px;
  font-weight: 400;
  font-size: 14px;
  line-height: 35px;
  letter-spacing: 0.25px;
  color: #686868;
}
.normal-bottom-box-nameType {
  height: 25px;
  width: 80px;
  display: inline-block;
  font-weight: 400;
  font-size: 14px;
  line-height: 30px;
  letter-spacing: 0.25px;
  color: #686868;
}

.right-box {
  /* flex: 1; */
  padding-top: 75px;
  box-sizing: border-box;
  padding-left: 60px;
  width: 48%;
}
.right-normal-box {
  height: 105px;
  width: 95%;
  margin-bottom: 15px;
}
.right-box-top {
  height: 22px;
  line-height: 22px;
  width: 441px;
  border-bottom: 1px solid #686868;
  font-weight: 700;
  font-size: 14px;
  color: #686868;
}
.right-box-bottom {
  height: 80px;
  line-height: 20px;
  font-weight: 400;
  font-size: 14px;
  letter-spacing: 0.25px;
  color: #686868;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
}

.line-button-box {
  height: 40px;
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 30px;
  padding: 0 0 0 55px;
  box-sizing: border-box;
}
.button-css1 {
  width: 85px;
  height: 40px;
  background: #fafafa;
  border: 1px solid #51abff;
  box-sizing: border-box;
  border-radius: 4px;
  font-weight: 500;
  font-size: 12px;
  color: #51abff;
  margin-right: 25px;
  cursor: pointer;
}
.button-css2 {
  width: 150px;
  height: 40px;
  background: #fc630c;
  border-radius: 4px;
  box-sizing: border-box;
  border-radius: 4px;
  font-weight: 500;
  font-size: 12px;
  color: #fff;
  cursor: pointer;
}

</style>



// WEBPACK FOOTER //
// src/pages/adminPostAddPageProgressThree/index.vue